import { queryClient, apiRequest } from "../lib/queryClient";

const notificationKey = "notifications";

export function useNotifications(options = {}) {
  const {
    filters = {},
    sort = { direction: "desc" },
    pagination = { page: 1, limit: 10 },
  } = options;

  const fetchNotification = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", pagination.page);
    queryParams.append("limit", pagination.limit);
    queryParams.append("sortField", sort.field);
    queryParams.append("sortDirection", sort.direction);
    for (const [key, value] of Object.entries(filters)) {
      queryParams.append(key, value);
    }
    if (filters.status && filters.status !== "all") {
      queryParams.append("status", filters.status);
    }
    if (filters.notification && filters.notification !== "all") {
      queryParams.append("notification", filters.notification);
    }
    if (filters.search) {
      queryParams.append("search", filters.search);
    }
    const response = await apiRequest(
      `/admin/notification?${queryParams.toString()}`,
      {
        method: "GET",
      }
    );

    return response;
  };

  const createNotification = async (userData, notification_type) => {
    const response = await apiRequest(
      `/admin/notification/${notification_type}`,
      {
        method: "POST",
        body: JSON.stringify(userData),
      }
    );
    return response;
  };

  const updateNotification = async ({ id, userData }) => {
    const response = await apiRequest(`/admin/notification/${id}`, {
      method: "PUT",
      body: JSON.stringify(userData),
    });
    queryClient.invalidateQueries({ queryKey: [notificationKey] });
    return response;
  };

  const deleteNotification = async (userId) => {
    await apiRequest(`/admin/notification/${userId}`, {
      method: "DELETE",
    });
    queryClient.invalidateQueries({ queryKey: [notificationKey] });
    return userId;
  };

  const resendNotification = async (notificationId) => {
    const response = await apiRequest(`/admin/notification/${notificationId}`, {
      method: "PATCH",
    });
    return response;
  };

  return {
    fetchNotification,
    createNotification,
    updateNotification,
    deleteNotification,
    resendNotification,
  };
}
